var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7333 13.0662C20.7333 18.5104 16.8542 21.2325 12.2435 22.8114C12.0021 22.8917 11.7398 22.8879 11.5009 22.8005C6.87917 21.2325 3 18.5104 3 13.0662V5.44426C3 5.15548 3.11677 4.87852 3.32462 4.67433C3.53248 4.47013 3.81439 4.35541 4.10833 4.35541C6.325 4.35541 9.09583 3.04879 11.0243 1.39375C11.2591 1.19666 11.5578 1.08838 11.8667 1.08838C12.1755 1.08838 12.4742 1.19666 12.709 1.39375C14.6486 3.05968 17.4083 4.35541 19.625 4.35541C19.9189 4.35541 20.2009 4.47013 20.4087 4.67433C20.6166 4.87852 20.7333 5.15548 20.7333 5.44426V13.0662Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/SecurityIcon.772bfe6f1fd71ddc190f2ef65e199e3c.svg";
export { ForwardRef as ReactComponent };